import type { LimitItem } from "../types";
import { fmtUSD } from "../lib/format";

type Props = { items: LimitItem[] };

const colorForState = (state: LimitItem["state"]): string => {
  switch (state) {
    case "bad":
      return "var(--tp-bad)";
    case "warn":
      return "var(--tp-warn)";
    case "ok":
      return "var(--tp-ok)";
    default:
      return "var(--tp-fg-3)";
  }
};

const renderValue = (it: LimitItem): string => {
  if (it.unit === "%") {
    return `${it.used}% / ${it.cap}%`;
  }
  if (it.unit === "days") {
    return `${it.used} / ${it.cap} (5d)`;
  }
  if (it.unit === "count") {
    return `${it.used} / ${it.cap}`;
  }
  return `${fmtUSD(it.used)} / ${fmtUSD(it.cap)}`;
};

export const LimitMeter = ({ items }: Props) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
    {items.map((it) => {
      const pct = Math.min(100, (it.used / it.cap) * 100);
      return (
        <div key={it.label} className="tp-meter">
          <div className="label">{it.label}</div>
          <div className="value" style={{ color: colorForState(it.state) }}>
            {renderValue(it)}
            <span style={{ color: "var(--tp-fg-4)", marginLeft: 6, fontSize: 11 }}>
              {Math.round(pct)}%
            </span>
          </div>
          <div className="tp-meter-bar">
            <div className={`fill ${it.state}`} style={{ width: pct + "%" }} />
          </div>
        </div>
      );
    })}
  </div>
);
